<div class="data-table">
	<table class="mdc-data-table__table">
		<caption>
			&nbsp;
		</caption>
		<thead>
			<tr class="mdc-data-table__header-row">
				<!-- <th class="mdc-data-table__header-cell mdc-col-sortable" *ngFor="let column of columns" (click)="sort(column.key)"
          [class.mdc-col-sorted-asc]="sortColumn === column.key && sortDirection === 'asc'"
            [class.mdc-col-sorted-desc]="sortColumn === column.key && sortDirection === 'desc'">
          {{ column.label }}
        </th> -->
				<th class="mdc-data-table__header-cell" *ngFor="let column of columns" (click)="sort(column.key)">
					{{ column.label }}
				</th>
			</tr>
		</thead>
		<tbody class="mdc-data-table__content">
			<tr
				class="mdc-data-table__row data-table-row"
				*ngFor="let item of paginatedData"
				(click)="selectRow(item)"
				[class.selected-row]="item === selectedItem"
			>
				<td class="mdc-data-table__cell" *ngFor="let column of columns" [style.width]="column.width || 'auto'">
					<app-carpa-data-table-column [item]="item" [columnConfig]="column"></app-carpa-data-table-column>
				</td>
				<!-- <td>
          <button class="action-button" (click)="handleAction('edit', item)">Edit</button>
          <button class="action-button" (click)="handleAction('delete', item)">Delete</button>
        </td> -->
			</tr>
		</tbody>
	</table>
	<div class="pagination mdc-data-table__pagination">
		<div class="pagination-left">
			<span>Page: </span>
			<button
				class="pagination-button"
				*ngFor="let page of totalPagesArray"
				(click)="changePage(page)"
				[ngClass]="{ active: currentPage === page }"
			>
				{{ page }}
			</button>
			<button class="pagination-button" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">&lt;</button>
			<button class="pagination-button" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">&gt;</button>
		</div>
		<div class="items-per-page">
			Lignes par page:
			<select (change)="onItemsPerPageChange($event)">
				<option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
			</select>
		</div>
	</div>
</div>
